import { render, staticRenderFns } from "./searchPoint.vue?vue&type=template&id=b952aa02&scoped=true"
import script from "./searchPoint.vue?vue&type=script&lang=js"
export * from "./searchPoint.vue?vue&type=script&lang=js"
import style0 from "./searchPoint.vue?vue&type=style&index=0&id=b952aa02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b952aa02",
  null
  
)

export default component.exports